import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Typography,
	Divider,
	Collapse
} from '@material-ui/core';

import AuthorizedUserContext from "../utils/AuthorizedUserContext";

const styles = makeStyles(theme => ({
	detail: {
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		marginTop: theme.spacing(2)
	},

	matchedTitle: {
		marginTop: theme.spacing(2)
	},

	matched: {
		marginBottom: theme.spacing(1)
	},

	oddEntry: {
		backgroundColor: theme.palette.grey[200]
	}
}));

function Associations(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	let classes = styles(),
		{content, expand} = props;

	content.map((panel, i) => {
		if(typeof panel.details === 'object') {
			panel.details.map((panelDetail, i) => {
				// Fix commas without a space after
				let re = /(,(?=[\S\n]))/;
				let detailContent = panelDetail.detail;
				panelDetail.detail = detailContent.replace(re, '$1 ');

				// Locations to string
				/*if(typeof panelDetail.locations === 'object' && panelDetail.locations.length > 0) {
					//panelDetail.locations = panelDetail.locations.join('\n');
					panel.panelExpand = true;
				}*/

				return panel;
			});
		}

		content[i] = panel;
		return content;
	});

	return (
		content.map((panel, i) =>
			<div key={i}>
				<Typography>{panel.method}</Typography>
				<Collapse in={expand}>
					<Typography color="textSecondary" className={classes.detail}>
						{panel.details.map((panelDetail, i) =>
							<span key={i}>
								{panelDetail.detail}
								{panel.details.length === i + 1 ? "" : ". "}
							</span>
						)}
					</Typography>
					<div className={classes.matchedTitle}>
						<Typography color="textSecondary">Locations Matched</Typography>
						<Divider />
					</div>
					{panel.details.map((panelDetail, i) => {
						return (
							<Typography
								key={i}
								color="textSecondary"
								className={`${classes.matched} ${(i % 2 === 1) ? classes.oddEntry : null}`}>
								{panelDetail.locations.map((line, i, arr) => {
									if (authenticatedUser.childAccounts && authenticatedUser.childAccounts.length) {
										let strippedAccnt = authenticatedUser.childAccounts.find(
											item => item.id === line.accountId
										);
										if (strippedAccnt) {
											line.name = line.name.replace(/\([^)]+\)/ig, `(${strippedAccnt.name})`);
										}
									}

									line = <span style={{display: "block"}} key={i}>{line.name}</span>;
									return line;
								})}
							</Typography>
						);
					})}
				</Collapse>
			</div>
		)
	);
}

Associations.propTypes = {
	content: PropTypes.array,
	expand: PropTypes.bool
};

export default Associations;